module.exports = __webpack_public_path__ + "static/media/42.e03c803b.png";